// extracted by css-extract-rspack-plugin
export default {"icon":"_bb39cd04"};